module.exports = __webpack_public_path__ + "img/shsb.75ec69a9.png";